/*----------------------------------
- MEGAMENU PANEL COPY (SSOT)
-----------------------------------*/

/**
 * The few words of the desktop panels that are not a row. The panels open straight on their
 * columns since the redraw of 2026-11-02 (Gaetan: "no head", mock parity web-recheck-01 to 03):
 * the headlines, leads, "News updated" line and "Open the screener" button went, so the only
 * copy left is the endings column's link to the hub. The column titles live with their rows
 * (`DOMAINS_MENU_COLUMN_TITLES`, the Market and Tools groups).
 */
export const LANDING_MENU_PANEL_COPY = {
    domains: {
        /** Under the endings column: every TLD page is listed on the hub, not only the few the panel shows. */
        allTldsLabel: 'See all TLDs',
    },
} as const;

/*----------------------------------
- TYPES
-----------------------------------*/

/** One titled group of rows: a column of the desktop panel, a titled list in the phone sheet (decision E2 = B). */
export type LandingMenuGroup<Item> = {
    id: string;
    /** The column title, sentence case, in ink on the desktop panel and in the sheet's label style on a phone. */
    title: string;
    items: readonly Item[];
};
